import { gql } from "@apollo/client";

export const AddStckRetrieItemDetails = gql`
  mutation AddStckRetrieItemDetails(
    $token: String!
    $customer_id: ID!
    $input: CreateAtsStckRetrieItemDetailsInput!
    $user_details: SubscribedUser!
  ) {
    AddStckRetrieItemDetails(
      token: $token
      customer_id: $customer_id
      input: $input
      user_details: $user_details
    )
  }
`;
